import { generalService } from "../services/index";

import * as types from "../types";
import { dispatch, generateUID } from "./util";
import messages from "../util/messages";

export const loginAction = (username, password, history = null, redirectTo = null) => {
  dispatch(types.FETCHING);
  const deviceId = localStorage.getItem("deviceId") || generateUID()
  sessionStorage.setItem("usernameLFS", username);
  generalService()
    .loginService({ username, password, deviceId })
    .then((res) => {
      if (!isToken()) {
        dispatch(types.FETCHING_END);
      }
      if (res.data && res.data.token) {
        sessionStorage.setItem("tokenAuthLFS", res.data.token);
        sessionStorage.setItem("rolesLFS", res.data.roles);
        let tmp = [];
        for (let i in res.data.actions) {
          if (res.data.actions[i].allow) {
            tmp.push(res.data.actions[i].name);
          }
        }
        sessionStorage.setItem("actionsLFS", tmp);
        dispatch(types.ADD_ALERT_NOTIFICATION, { message: messages[types.LOGIN_SUCCESS], color: 'info' });
        if (!res.data?.twoFactorAuth?.isDeviceChecked) {
          sessionStorage.setItem("twoFactor", JSON.stringify(res.data.twoFactorAuth));
        }
        localStorage.setItem("deviceId", deviceId)
        if (sessionStorage.getItem("reloadLFS")) {
          sessionStorage.removeItem("reloadLFS");
        }
        
        // If redirectTo is specified and history is available, navigate to specific route
        if (redirectTo && history) {
          history.push(redirectTo);
        }
        
        window.location.reload();
      }
    })
    .catch((err) => {
      dispatch(types.FETCHING_END);
      dispatch(types.ADD_ALERT_NOTIFICATION, { message: err.response?.data?.message || messages[types.LOGIN_FAILURE], color: 'danger' });
    });
};
export const loginActionAzure = async (username, password, history) => {
  dispatch(types.FETCHING);
  const deviceId = localStorage.getItem("deviceId") || generateUID()
  sessionStorage.setItem("usernameLFS", username);

  generalService()
    .loginAzureService({ username, password, deviceId })
    .then((res) => {
      if (!isToken()) {
        dispatch(types.FETCHING_END);
      }
      if (res.data && res.data.token) {
        sessionStorage.setItem("tokenAuthLFS", res.data.token);
        sessionStorage.setItem("rolesLFS", res.data.roles);
        let tmp = [];
        for (let i in res.data.actions) {
          if (res.data.actions[i].allow) {
            tmp.push(res.data.actions[i].name);
          }
        }
        sessionStorage.setItem("actionsLFS", tmp);
        dispatch(types.ADD_ALERT_NOTIFICATION, { message: messages[types.LOGIN_SUCCESS], color: 'info' });
        if (!res.data?.twoFactorAuth?.isDeviceChecked) {
          sessionStorage.setItem("twoFactor", JSON.stringify(res.data.twoFactorAuth));
        }
        localStorage.setItem("deviceId", deviceId)
        if (sessionStorage.getItem("reloadLFS")) {
          sessionStorage.removeItem("reloadLFS");
        }
      }
      history.push(0)
      window.location.reload();

    })
    .catch((err) => {
      dispatch(types.ADD_ALERT_NOTIFICATION, { message: err.response?.data?.message || messages[types.LOGIN_FAILURE], color: 'danger' });

      dispatch(types.FETCHING_END);
      sessionStorage.clear()
      history.push(0)
    });
};

export const set2FA = (username, code) => {
  dispatch(types.FETCHING);
  const deviceId = localStorage.getItem("deviceId") || generateUID()
  generalService()
    .twoFactorService({ username, code, deviceId })
    .then(res => {

      if (res.data && res.data.token) {
        sessionStorage.removeItem('twoFactor')
        sessionStorage.setItem("tokenAuthLFS", res.data.token);
        sessionStorage.setItem("rolesLFS", res.data.roles);
        let tmp = [];
        for (let i in res.data.actions) {
          if (res.data.actions[i].allow) {
            tmp.push(res.data.actions[i].name);
          }
        }
        const beforeAction = sessionStorage.getItem("actionsLFS");
        sessionStorage.setItem("actionsLFS", tmp);
        if (beforeAction !== tmp.toString()) {
          window.location.reload();
        } else {
          dispatch(types.ADD_ALERT_NOTIFICATION, { message: messages[types.LOGIN_SUCCESS], color: 'info' });
          dispatch(types.HIDE_AUTH_MODAL);
        }
      } else {
        dispatch(types.ADD_ALERT_NOTIFICATION, { message: messages[types.TWO_FACTOR_AUTH_FAILURE_CODE], color: 'danger' });
      }
      dispatch(types.FETCHING_END);
    })
    .catch((err) => {
      dispatch(types.FETCHING_END);
      dispatch(types.ADD_ALERT_NOTIFICATION, { message: err.response?.data?.message || messages[types.TWO_FACTOR_AUTH_FAILURE], color: 'danger' });
    });
};

export const logoutAction = (noDispatch) => {
  sessionStorage.removeItem("usernameLFS");
  sessionStorage.removeItem("tokenAuthLFS");
  sessionStorage.removeItem("rolesLFS");
  sessionStorage.removeItem("twoFactor");
  if (!noDispatch) {
    dispatch(types.SHOW_AUTH_MODAL);
  }
};

export const refreshTokenAction = () => {
  if (sessionStorage.getItem("twoFactor")) {
    return
  }
  generalService()
    .refreshTokenService()
    .then((res) => {
      if (res.data && res.data.token) {
        sessionStorage.setItem("tokenAuthLFS", res.data.token);
        sessionStorage.setItem("rolesLFS", res.data.roles);
        let tmp = [];
        for (let i in res.data.actions) {
          if (res.data.actions[i].allow) {
            tmp.push(res.data.actions[i].name);
          }
        }
        const beforeAction = sessionStorage.getItem("actionsLFS");
        sessionStorage.setItem("actionsLFS", tmp);
        if (beforeAction !== tmp.toString()) {
          window.location.reload();
        }
      }
    })
    .catch((err) => {
    });
};

export const isToken = () => !!sessionStorage.getItem("tokenAuthLFS");

let refreshTokenInterval = 0;

if (isToken()) {
  refreshTokenAction();
  clearInterval(refreshTokenInterval);
  refreshTokenInterval = setInterval(() => {
    if (isToken()) {
      refreshTokenAction();
    }
  }, 60 * 1000 * 60 * 2);
}
